<template>
  <v-container v-if="offerData.id" :loading="loading">
    <v-app-bar app fixed style="top:64px">
      <v-row>
        <v-col>
          <v-layout row>
            <v-dialog v-model="addPositionDialog" persistent max-width="500">
              <template #activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                  Position hinzufügen
                </v-btn>
              </template>
              <v-card>
                <form @submit.prevent="submitAddPosition">
                  <v-card-title class="headline">
                    Position hinzufügen
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col>
                        <v-autocomplete
                          v-model="positionToAdd"
                          :items="possiblePositions"
                          item-value="id"
                          :item-text="positionText"
                          label="Position"
                          :filter="filterPossiblePositions"
                          clearable
                          return-object
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="primary"
                      @click.native="addPositionDialog = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn color="primary" type="submit">
                      Save
                    </v-btn>
                  </v-card-actions>
                </form>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="currentPositions"
          dense
          disable-sort
          disable-pagination
          hide-default-footer
        >
          <template #body="{items: positions}">
            <tbody>
              <template v-for="(position, posindex) in positions">
                <tr :key="position.id" style="background-color: gray;">
                  <td>{{ posindex + 1 }}</td>
                  <td>{{ position.title }}</td>
                  <td colspan="2" />
                </tr>
                <tr v-if="position.zweck_t" :key="position.id">
                  <td>Zweck</td>
                  <td>{{ position.zweck_t }}</td>
                  <td colspan="2" />
                </tr>
                <template v-for="(positionItem, itemindex) in position.items">
                  <tr :key="positionItem.id">
                    <td>{{ posindex + 1 }}.{{ itemindex+1 }}</td>
                    <td>{{ positionItem.title }}</td>
                    <td>{{ positionItem.minAmount }}</td>
                    <td>
                      <v-edit-dialog
                        :return-value.sync="positionItem.amount"
                        large
                        save-text="speichern"
                        cancel-text="zurück"
                        @save="updatePositionItem(positionItem)"
                      >
                        <div>{{ positionItem.amount }}</div>
                        <template #input>
                          <div class="mt-4">
                            Update Amount
                          </div>
                          <v-text-field
                            v-model="positionItem.amount"
                            type="number"
                            label="Anzahl"
                            autofocus
                            number
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                  </tr>
                </template>

                <tr :key="`additional_${position.id}`">
                  <td />
                  <td @click="addItem(position.id)">
                    Add Item
                  </td>
                  <td colspan="2" />
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row ref="newPositionAncor">
      <v-col cols="3">
        <v-menu
          ref="startDateMenu"
          v-model="startDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="enlargementCreation.startDate"
              label="Startdatum"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="enlargementCreation.startDate"
            :active-picker.sync="startDateActivePicker"
            :max="
              new Date(
                new Date().setMonth(new Date().getMonth() + 6)
              )
                .toISOString()
                .substr(0, 10)
            "
            :min="
              new Date(
                new Date().setMonth(new Date().getMonth() - 6)
              )
                .toISOString()
                .substr(0, 10)
            "
          />
        </v-menu>
      </v-col>
      <v-col>
        <v-btn class="primary" @click="submit">
          Vertragserweiterung speichern
        </v-btn>
      </v-col>
    </v-row>
    <v-layout row justify-center>
      <v-dialog v-model="addItemDialog" persistent max-width="500">
        <v-card>
          <form @submit.prevent="submitAddItem">
            <v-card-title class="headline">
              Item zu Position hinzufügen
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="addItemForm.itemId"
                    :items="items"
                    item-value="id"
                    :error-messages="itemIdErrors"
                    :item-text="itemText"
                    label="Item"
                    :filter="filterItems"
                    clearable
                    @blur="$v.addItemForm.itemId.$touch()"
                  />
                  <v-text-field
                    v-model="addItemForm.amount"
                    type="number"
                    label="Anzahl"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="error" @click.native="addItemDialog = false">
                Cancel
              </v-btn>
              <v-btn color="primary" type="submit">
                Add
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import { validationMixin } from 'vuelidate'
import { required, minValue } from 'vuelidate/lib/validators'
function inItems (value) {
   return this.items.find(({ id }) => id === value) !== undefined
}

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Vertragserweiterung',
      }
   },
   mixins: [validationMixin],
   layout: (h, page) => h(Layout, [page]),
   props: {
      offerData: {
         type: Object,
         required: true,
      },
      contract: {
         type: Object,
         required: true,
      },
      items: {
         type: Array,
         required: true,
      },
      products: {
         type: Array,
         required: true,
      },
      bundles: {
         type: Array,
         required: true,
      },
      newPositions: {
         type: Array,
         required: true,
      },
   },
   validations: {
      addItemForm: {
         itemId: { required, inItems },
         amount: { required, minValue: minValue(0) },
      },
   },
   data () {
      return {
         addItemForm: this.$inertia.form({
            itemId: null,
            amount: null,
         }),
         addPositionForm: this.$inertia.form({
            id: null,
            type: null,
         }),
         addPositionDialog: false,
         addItemDialog: false,
         editingPosition: null,
         loading: true,
         positionToAdd: null,
         tab: 0,
         headers: [
            {
               text: 'Pos.',
               align: 'start',
               filterable: false,
               value: 'pos',
            },
            { text: 'Beschreibung', value: 'title' },
            { text: 'min', value: 'minAmount' },
            { text: 'Anz.', value: 'amount' },
         ],
         enlargementCreation: this.$inertia.form({
            startDate: new Date().toISOString().substr(0, 10),
            newPositions: [],
            updatedPositions: []
         }),
         startDateActivePicker: 'MONTH',
      }
   },
   computed: {
      amountErrors () {
         const errors = this.$page.props.errors.amount ?? []
         if (!this.$v.addItemForm.amount.$dirty) return errors
         !this.$v.addItemForm.amount.required &&
        errors.push('Amount is required.')
         !this.$v.addItemForm.amount.minValue &&
        errors.push('Amount must be greater 0')
         return errors
      },
      itemIdErrors () {
         const errors = this.$page.props.errors.itemId ?? []
         if (!this.$v.addItemForm.itemId.$dirty) return errors
         !this.$v.addItemForm.itemId.required && errors.push('Field is required.')
         !this.$v.addItemForm.itemId.inItems &&
        errors.push('Muss einem Artikel entsprechen')

         return errors
      },
      possiblePositions () {
         return this.bundles.concat(this.products)
      },
      currentPositions () {
         const currentPositions = []
         currentPositions.push(...this.offerData.positions)
         currentPositions.push(...this.newPositions)
         return currentPositions
      }
   },
   watch: {
      startDateMenu (val) {
         val && setTimeout(() => (this.startDateActivePicker = 'MONTH'))
      },
   },
   methods: {
      positionBackground (pos) {
         return {
            backgroundColor:
          pos !== undefined && !String(pos).includes('.')
             ? 'gray'
             : 'transparent',
         }
      },
      updatePositionItem (val) {
         if (this.enlargementCreation.updatedPositions.find(({ id }) => id === val.id) === undefined && !val.id.toString().startsWith('add')) {
            this.enlargementCreation.updatedPositions.push(
               val
            )
         }
      },
      addItem (position) {
         this.editingPosition = position
         this.addItemDialog = true
      },
      submitAddItem () {
         this.$v.$touch()
         if (!this.$v.$invalid) {
            const data = this.addItemForm.data()
            const item = this.items.find(({ id }) => id === data.itemId)
            let position = this.offerData.positions.find(({ id }) => id === this.editingPosition)
            if (!position) {
               position = this.newPositions.find(({ id }) => id === this.editingPosition)
            }
            data.id = `add_${this.enlargementCreation.updatedPositions.length}`
            data.offer_data_position_id = this.editingPosition
            data.title = this.itemText(item)
            data.minAmount = 0
            this.enlargementCreation.updatedPositions.push(
               data
            )
            position.items.push(data)
            const oldId = position.id
            position.id = 'update'
            this.addItemDialog = false
            this.editingPosition = null
            this.addItemForm.reset()
            this.$v.$reset()
            this.$nextTick(() => {
               position.id = oldId
            })
         }
      },
      submitAddPosition () {
         const data = this.addPositionForm.data()
         if (this.positionToAdd.last_data[0].bundle_id) {
            data.id = this.positionToAdd.last_data[0].bundle_id
            data.type = 'Bundle'
         } else {
            data.id = this.positionToAdd.last_data[0].product_id
            data.type = 'Product'
         }
         this.enlargementCreation.newPositions.push(
            data
         )
         data.items = []
         data.title = this.positionText(this.positionToAdd)
         this.newPositions.push(
            data
         )
         this.addPositionDialog = false
         this.positionToAdd = null
         this.addPositionForm.reset()
         this.$v.$reset()
         this.$vuetify.goTo(this.$refs.newPositionAncor)
      },

      itemText (item) {
         return item.product.last_data[0].name + ' - ' + item.last_data[0].name
      },
      positionText (item) {
         return item.last_data[0].name
      },
      filterItems (item, queryText, itemText) {
         const textOne = item.product.last_data[0].name.toLowerCase()
         const textTwo = item.last_data[0].name.toLowerCase()
         const searchText = queryText.toLowerCase()

         return (
            textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
         )
      },
      filterPossiblePositions (item, queryText, itemText) {
         const searchText = queryText.toLowerCase()
         const textOne = item.last_data[0].name.toLowerCase()

         return textOne.indexOf(searchText) > -1
      },
      submit () {
         this.enlargementCreation.post(
            this.route('contracts.enlargements.store', {
               contract: this.contract.id,
            })
         )
      }
   },
}
</script>
